import RolesListTemplate from "app/features/userRoles/roles/templates/RolesListTemplate";

export default function RolesScreen() {
  return <RolesListTemplate />;
}
